export { default } from './ClientLogoByOrganisationCode';
